import { createSvgIcon } from '@material-ui/core/utils';

export const DataMeshTaxonomyIcon = createSvgIcon(
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 1.33334L14.6667 8.00001L8 14.6667L1.33334 8.00001L8 1.33334ZM2.6415 8.00001L8 13.3585L13.3585 8.00001L8 2.64151L2.6415 8.00001Z" />
  </svg>,
  'DataMeshTaxonomyIcon',
);
